import VotreVelo from '@/steps/1-votre-velo';
import VotreBesoin from '@/steps/2-votre-besoin';
import Recapitulatif from '@/steps/3-recapitulatif';
import RecapGPT from '@/steps/recap-gpt';
import TarifWithPromo from '@/steps/tarif-with-promo';
import SelectionMotifAvenant from '@/steps/selection-motif-avenant';
import {
    AttentePaiementStep,
    ConsentementEmailStep,
    showConsentementEmailStep,
    CoordonneesConsentStep,
    DocumentsStep,
    InformationsStep,
    PaiementStep,
    PrelevementStep,
    SignatureStep,
    ValidationStep,
    ValidationPaiementAvenant,
} from '@workspace/core-ts/components';
import type { StepProps } from '@workspace/core-ts/utils';
import { addIndexToSteps } from '@workspace/core-ts/utils';
import { excludeRestrictedPostalCodes } from '@workspace/utils';
import { AvReasonKeyValue } from '@/AvReason';
import { paiementStepContent } from '@/content/paiement';

// eslint-disable-next-line react-refresh/only-export-components
export default addIndexToSteps([
    {
        slug: 'selection-motif-avenant',
        title: 'Motif avenant',
        path: '/selection-motif-avenant',
        element: SelectionMotifAvenant,
        isAffaireNouvelle: false,
    },
    {
        slug: 'votre-velo',
        title: 'Votre vélo',
        path: '/',
        element: VotreVelo,
        avenantMotifs: [AvReasonKeyValue.CHANGEMENT_VELO, AvReasonKeyValue.MISE_A_JOUR_DECLARATION],
    },
    {
        slug: 'votre-besoin',
        title: 'Votre besoin',
        path: '/besoin',
        element: VotreBesoin,
        avenantMotifs: [AvReasonKeyValue.CHANGEMENT_VELO, AvReasonKeyValue.MISE_A_JOUR_DECLARATION],
    },
    {
        slug: 'recap-gpt',
        title: 'Récapitulatif',
        path: '/recap-gpt',
        element: RecapGPT,
        showWhen: (_state, initialState) =>
            ['AppGPT', 'AgentConv'].includes(initialState?.DemandeDevis?.TypeMER),
    },
    {
        slug: 'votre-tarif',
        title: 'Votre tarif',
        path: '/tarif',
        element: TarifWithPromo,
    },
    {
        // Uniquement pour les apporteurs qui recueillent le consentement e-mail, hors avenant
        slug: 'preferences-email',
        title: 'Vos préférences',
        path: '/preferences-email',
        element: ConsentementEmailStep,
        isAvenant: false,
        showWhen: showConsentementEmailStep,
    },
    {
        slug: 'informations',
        title: 'Vos informations',
        path: '/informations',
        element: InformationsStep,
    },
    {
        slug: 'vos-coordonnees',
        title: 'Vos coordonnées',
        path: '/coordonnees',
        element: () => (
            <CoordonneesConsentStep
                validationCP={{
                    validate: {
                        excludeRestrictedRegions: excludeRestrictedPostalCodes,
                    },
                }}
            />
        ),
    },
    {
        slug: 'recapitulatif',
        title: 'Récapitulatif',
        path: '/recapitulatif',
        element: Recapitulatif,
    },
    {
        slug: 'validation-paiement-avenant',
        title: 'Validation',
        path: '/validation-paiement-avenant',
        element: ValidationPaiementAvenant,
        isAffaireNouvelle: false,
    },
    {
        slug: 'prelevement',
        title: 'Prélèvement',
        path: '/prelevement',
        element: () => (
            <PrelevementStep
                showConditions={false}
                enableTiersPayeur={true}
            />
        ),
        isAvenant: false,
    },
    {
        slug: 'paiement',
        title: 'Paiement',
        path: '/paiement',
        element: () => <PaiementStep content={paiementStepContent} embedded />,
        isAvenant: false,
    },
    {
        slug: 'attente-paiement',
        title: 'Attente de paiement',
        path: '/attente-paiement',
        element: () => <AttentePaiementStep />,
        source: ['conseiller', 'courtier'],
        isAvenant: false,
    },
    {
        slug: 'validation',
        title: 'Validation',
        path: '/validation',
        element: () => <ValidationStep />,
        isAvenant: false,
    },
    {
        slug: 'signature',
        title: 'Signature électronique',
        path: '/signature',
        element: () => <SignatureStep showHeaderIcon={true} />,
    },
    {
        slug: 'pieces-justificatives',
        title: 'Pièces justificatives',
        path: '/envoi-des-pieces',
        element: () => <DocumentsStep showIcon={true} />,
    },
]) as StepProps[];
